import {Directive, ElementRef, OnInit} from '@angular/core';
import {TokenService} from '../../services/token.service';
import {LoggingService} from '../../services/logging';

@Directive({
  selector: '[isSIDRAdmin]'
})
export class IsSIDRAdminDirective implements OnInit {

  constructor(private el: ElementRef, private tokenService: TokenService, private log: LoggingService) {
    this.el.nativeElement.style.display = 'none';
  }

  ngOnInit(): void {
    const sidrAdmin = this.tokenService.getUserToken()?.sidrAdmin ?? false;
    this.log.Log(`isSIDRAdmin ${sidrAdmin}`);
    if (sidrAdmin) {
      this.el.nativeElement.style.display = '';
    } else {
      this.el.nativeElement.style.display = 'none';
    }
  }
}
